export const task_status = {
    IN_PROGRESS: 'In Progress',
    COMPLETED : 'Completed',
}

